import { jsxs as M, jsx as a } from "react/jsx-runtime";
import { useMemo as b } from "react";
const N = {
  small: {
    base: 48,
    icon: 18,
    stroke: 1.5
  },
  medium: {
    base: 64,
    icon: 24,
    stroke: 2
  },
  large: {
    base: 80,
    icon: 30,
    stroke: 2.5
  }
}, P = {
  GOOD: "#226a58",
  BAD: "#9B0505",
  WARNING: "#DB5E04",
  PARTIALLY_GOOD: "#DB5E04",
  UNKNOWN: "#9E9E9E",
  NA: "#9E9E9E"
}, y = ({
  parameters: r,
  size: d = "medium",
  type: m = "outdoor",
  onClick: x,
  showSector: w = !0
}) => {
  const s = b(() => N[d], [d]), $ = b(() => P[r.health], [r.health]), L = () => {
    if (!w)
      return null;
    const e = s.base / 2, o = e / 1.4 - s.stroke;
    if ("angle" in r) {
      const { angle: l, beamwidth: n, gain: t, channelColor: c } = r;
      return h(l, n, t, c || "#000000", e, o);
    }
    return r.sectors.map((l, n) => {
      const { angle: t, beamwidth: c, gain: C, channelColor: u } = l;
      return h(t, c, C, u, e, o, n);
    });
  }, h = (e, o, l, n, t, c, C = 0) => {
    const p = Math.min(l || 0, 30) / 30, i = c + c * (p * 0.5), A = e - o / 2, E = e + o / 2, g = A * Math.PI / 180, f = E * Math.PI / 180, v = t + i * Math.sin(g), I = t - i * Math.cos(g), O = t + i * Math.sin(f), Z = t - i * Math.cos(f), B = o > 180 ? 1 : 0, G = 1;
    return o === 0 || o === 360 ? /* @__PURE__ */ a(
      "circle",
      {
        cx: t,
        cy: t,
        r: i,
        fill: n + "88",
        stroke: n,
        strokeWidth: s.stroke
      },
      `sector-${C}`
    ) : /* @__PURE__ */ a(
      "path",
      {
        d: `M ${t} ${t} L ${v} ${I} A ${i} ${i} 0 ${B} ${G} ${O} ${Z} Z`,
        fill: n + "66",
        stroke: n,
        strokeWidth: s.stroke
      },
      `sector-${C}`
    );
  }, k = ({ type: e }) => e === "indoor" ? /* @__PURE__ */ a(
    "svg",
    {
      focusable: "false",
      "aria-hidden": "true",
      viewBox: "0 0 13 13",
      "data-test-id": "RadioIndoorPin",
      xmlns: "http://www.w3.org/2000/svg",
      x: (s.base - s.icon * 0.75) / 2,
      y: (s.base - s.icon * 0.75) / 2,
      width: s.icon * 0.75,
      height: s.icon * 0.75,
      children: /* @__PURE__ */ a("path", { d: "M1.33333 13C0.966667 13 0.652889 12.8696 0.392 12.6087C0.131111 12.3478 0.000444444 12.0338 0 11.6667V9.00004C0 8.63337 0.130667 8.3196 0.392 8.05871C0.653333 7.79782 0.967111 7.66715 1.33333 7.66671H8V5.00004H9.33333V7.66671H10.6667C11.0333 7.66671 11.3473 7.79737 11.6087 8.05871C11.87 8.32004 12.0004 8.63382 12 9.00004V11.6667C12 12.0334 11.8696 12.3474 11.6087 12.6087C11.3478 12.87 11.0338 13.0005 10.6667 13H1.33333ZM2.66667 11C2.85556 11 3.014 10.936 3.142 10.808C3.27 10.68 3.33378 10.5218 3.33333 10.3334C3.33289 10.1449 3.26889 9.98671 3.14133 9.85871C3.01378 9.73071 2.85556 9.66671 2.66667 9.66671C2.47778 9.66671 2.31956 9.73071 2.192 9.85871C2.06444 9.98671 2.00044 10.1449 2 10.3334C1.99956 10.5218 2.06356 10.6803 2.192 10.8087C2.32044 10.9372 2.47867 11.0009 2.66667 11ZM5 11C5.18889 11 5.34733 10.936 5.47533 10.808C5.60333 10.68 5.66711 10.5218 5.66667 10.3334C5.66622 10.1449 5.60222 9.98671 5.47467 9.85871C5.34711 9.73071 5.18889 9.66671 5 9.66671C4.81111 9.66671 4.65289 9.73071 4.52533 9.85871C4.39778 9.98671 4.33378 10.1449 4.33333 10.3334C4.33289 10.5218 4.39689 10.6803 4.52533 10.8087C4.65378 10.9372 4.812 11.0009 5 11ZM7.33333 11C7.52222 11 7.68067 10.936 7.80867 10.808C7.93667 10.68 8.00044 10.5218 8 10.3334C7.99956 10.1449 7.93556 9.98671 7.808 9.85871C7.68044 9.73071 7.52222 9.66671 7.33333 9.66671C7.14444 9.66671 6.98622 9.73071 6.85867 9.85871C6.73111 9.98671 6.66711 10.1449 6.66667 10.3334C6.66622 10.5218 6.73022 10.6803 6.85867 10.8087C6.98711 10.9372 7.14533 11.0009 7.33333 11ZM7.5 4.50004L6.53333 3.53337C6.82222 3.26671 7.14444 3.0556 7.5 2.90004C7.85556 2.74449 8.24444 2.66671 8.66667 2.66671C9.08889 2.66671 9.47778 2.74449 9.83333 2.90004C10.1889 3.0556 10.5111 3.26671 10.8 3.53337L9.83333 4.50004C9.67778 4.34449 9.50267 4.22226 9.308 4.13337C9.11333 4.04449 8.89956 4.00004 8.66667 4.00004C8.43378 4.00004 8.21978 4.04449 8.02467 4.13337C7.82956 4.22226 7.65467 4.34449 7.5 4.50004ZM5.83333 2.83337L4.9 1.90004C5.38889 1.41115 5.95556 1.02782 6.6 0.750041C7.24444 0.472263 7.93333 0.333374 8.66667 0.333374C9.4 0.333374 10.0889 0.472263 10.7333 0.750041C11.3778 1.02782 11.9444 1.41115 12.4333 1.90004L11.5 2.83337C11.1333 2.46671 10.7084 2.18071 10.2253 1.97537C9.74222 1.77004 9.22267 1.66715 8.66667 1.66671C8.11067 1.66626 7.59133 1.76915 7.10867 1.97537C6.626 2.1816 6.20089 2.4676 5.83333 2.83337Z", fill: "white" })
    }
  ) : /* @__PURE__ */ M(
    "svg",
    {
      focusable: "false",
      "aria-hidden": "true",
      viewBox: "0 0 24 24",
      "data-testid": "CellTowerIcon",
      x: (s.base - s.icon) / 2,
      y: (s.base - s.icon) / 2,
      width: s.icon,
      height: s.icon,
      children: [
        /* @__PURE__ */ a("path", { fill: "white", d: "m7.3 14.7 1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s.7 3.4 2 4.7M19.1 2.9l-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9s-.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1s-1-5.1-2.9-7.1" }),
        /* @__PURE__ */ a("path", { fill: "white", d: "M6.1 4.1 4.9 2.9C3 4.9 2 7.4 2 10s1 5.1 2.9 7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9s.8-4.3 2.4-5.9m10.6 10.6c1.3-1.3 2-3 2-4.7-.1-1.7-.7-3.4-2-4.7l-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-.5 2.6-1.5 3.5zM14.5 10c0-1.38-1.12-2.5-2.5-2.5S9.5 8.62 9.5 10c0 .76.34 1.42.87 1.88L7 22h2l.67-2h4.67l.66 2h2l-3.37-10.12c.53-.46.87-1.12.87-1.88m-4.17 8L12 13l1.67 5z" })
      ]
    }
  );
  return /* @__PURE__ */ M(
    "svg",
    {
      width: s.base,
      height: s.base,
      viewBox: `0 0 ${s.base} ${s.base}`,
      onClick: x,
      children: [
        L(),
        /* @__PURE__ */ a(
          "circle",
          {
            cx: s.base / 2,
            cy: s.base / 2,
            r: (s.base / 1.8 - s.stroke * 2) / 2,
            fill: $,
            filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
          }
        ),
        /* @__PURE__ */ a(k, { type: m })
      ]
    }
  );
};
export {
  y as default
};
